import React, { useEffect, useRef } from 'react';
import imagen from "../images/BOTStand.png";
import instagramLogo from "../images/logowapp.png"; // Asegúrate de tener este archivo en tu proyecto

const Right = () => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

    // Añade el gradiente sobre la imagen y luego coloca el logo de Instagram encima
    const cssString = `
      body, html {
        margin: 0;
        padding: 0;
        overflow: hidden;
        height: 100%;
        background-image: url('${imagen}');
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
      }

      .gradient-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0; /* Corregido a 0 para cubrir completamente el fondo */
        background: radial-gradient(ellipse at center, transparent, rgba(0, 0, 0, 0.8) 100%);
        pointer-events: none; /* Esto permite la interacción con el contenido debajo del gradiente */
        z-index: 1; /* Asegúrate de que el gradiente esté debajo del logo */
      }

      .instagram-logo {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 50px; /* O el tamaño que prefieras para el logo */
        height: 50px; /* O el tamaño que prefieras para el logo */
        cursor: pointer;
        z-index: 2; /* Esto coloca el logo encima del gradiente */
      }
    `;

    const styleEl = document.createElement("style");
    styleEl.textContent = cssString;
    iframeDoc.head.appendChild(styleEl);

    // Crea el overlay de gradiente
    const gradientOverlay = document.createElement("div");
    gradientOverlay.className = 'gradient-overlay';
    iframeDoc.body.appendChild(gradientOverlay);

    // Crea el enlace del logo de Whatsapp
    const instagramLink = document.createElement("a");
    instagramLink.href = "https://wa.link/f0s84s";
    instagramLink.target = "_blank";
    instagramLink.className = 'instagram-logo';

    // Crea el elemento de imagen para el logo
    const logoImg = document.createElement("img");
    logoImg.src = instagramLogo;
    logoImg.alt = "Instagram";
    logoImg.style.width = '100%'; // El logo ocupará el 100% del tamaño de su contenedor
    logoImg.style.height = '100%'; // El logo ocupará el 100% del tamaño de su contenedor

    // Añade el logo al enlace
    instagramLink.appendChild(logoImg);
    
    // Añade el enlace al cuerpo del documento del iframe
    iframeDoc.body.appendChild(instagramLink);
  }, []);

  // Añade un borde al iframe
  return <iframe ref={iframeRef} style={{ width: '100%', height: '100%', position: 'relative'}} title="Iframe Instagram Link"></iframe>;
};

export default Right;
